import { middlewareTypes } from './middleware-types';
import type { AsyncResult } from '../public-types';
import type { WrappedRequestor } from './wrapped-requestor';

export type MiddlewareNext<TResponse = unknown> = (
  _request: WrappedRequestor<object, TResponse>,
) => AsyncResult<TResponse>;
export type Middleware<TResponse = unknown> = (
  _next: MiddlewareNext<TResponse>,
) => MiddlewareNext<TResponse>;
export type MiddlewareCollection<TResponse = unknown> =
  | Array<Middleware<TResponse>>
  | Record<string, Middleware<TResponse>>;

function executeRequestor<TResponse>(wrappedRequestor: WrappedRequestor<object, TResponse>) {
  return wrappedRequestor.executeRequest();
}

export function requestWithMiddleware<TResponse>(
  wrappedRequestor: WrappedRequestor<object, TResponse>,
  middlewares: MiddlewareCollection<TResponse>,
) {
  const entries = Object.entries(middlewares);
  const orderedMiddlewares = [
    ...entries.filter(([key]) => key !== middlewareTypes.INSTRUMENTATION).map(([, value]) => value),
    ...entries.filter(([key]) => key === middlewareTypes.INSTRUMENTATION).map(([, value]) => value),
  ];
  const wrappedRequest = orderedMiddlewares.reduceRight<MiddlewareNext<TResponse>>(
    (next, middleware) => middleware(next),
    executeRequestor,
  );
  return wrappedRequest(wrappedRequestor);
}
